module.exports = __webpack_public_path__ + "static/thief_icon-6648b5d79e18456df8d154c76371e1e8.png";